import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getActiveMarketOrder } from 'games/PredictionMarket/slice-thunk/predictionMarket.thunk'
import { ORDER_SIDES } from 'games/PredictionMarket/predictionMarket.constants'

const MarketOrdersIndicator = ({ isLoggedIn }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { activeMarketOrder } = useSelector((state) => state.predictionMarket)

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getActiveMarketOrder())
    }
  }, [isLoggedIn, dispatch])

  if (!isLoggedIn) return null

  const isActive = !!activeMarketOrder

  return (
    <div className='market-orders-indicator'>
      <button
        type='button'
        className={`market-orders-indicator__trigger ${isActive ? 'market-orders-indicator__trigger--active' : 'market-orders-indicator__trigger--idle'}`}
        aria-label={isActive ? t('marketOrderInProgress') : t('noActiveMarketOrder')}
        tabIndex={-1}
      >
        {isActive
          ? (
            <svg viewBox='0 0 24 24' width='16' height='16' aria-hidden='true'>
              <circle cx='12' cy='12' r='9' fill='none' stroke='currentColor' strokeWidth='2' strokeDasharray='28 12' />
            </svg>
            )
          : (
            <svg viewBox='0 0 24 24' width='16' height='16' aria-hidden='true'>
              <path d='M5 12h14' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
            </svg>
            )}
      </button>

      <div className='market-orders-indicator__dropdown'>
        {isActive ? (
          <>
            <p className='market-orders-indicator__dropdown-title'>{t('marketOrderRunning')}</p>
            {activeMarketOrder.questionTitle && (
              <p className='market-orders-indicator__dropdown-market'>{activeMarketOrder.questionTitle}</p>
            )}
            {activeMarketOrder.optionTitle && (
              <p className='market-orders-indicator__dropdown-option'>{activeMarketOrder.optionTitle}</p>
            )}
            <div className='market-orders-indicator__dropdown-details'>
              <span>
                {activeMarketOrder.side === ORDER_SIDES.BID ? t('buy') : t('sell')} {activeMarketOrder.outcome ? t(activeMarketOrder.outcome) : ''}
              </span>
              {activeMarketOrder.side === ORDER_SIDES.BID ? (
                <span>{t('remainingAmount', { amount: Number(activeMarketOrder.remainingAmount ?? 0).toFixed(2) })}</span>
              ) : (
                <span>{t('remainingShares', { shares: Number(activeMarketOrder.remainingShares ?? 0).toFixed(2) })}</span>
              )}
              {activeMarketOrder.state && <span>{t('statusState', { state: t(activeMarketOrder.state) })}</span>}
            </div>
          </>
        ) : (
          <p className='market-orders-indicator__dropdown-empty'>
            {t('noMarketOrderRunning')}
          </p>
        )}
      </div>
    </div>
  )
}

export default MarketOrdersIndicator
